import * as yup from "yup";

export default messages => {
  return yup.object().shape({
    password: yup.string().required(messages.REQUIRED),
  });
};
